module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm1"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('div', {
    staticClass: "chapterBody"
  }, [_c('br'), _c('br'), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("Credit is due:")])]), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("As always, to my critique group, Mary, Marti, Cheryl, Chris and Michele, even though she swears she’ll never read another book by me ever again.")])]), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("To Sasha Bogin, an editor and a cheerleader, and Kelly Harms, my agent, who I imagine would make a wonderful pirate or hostage negotiator.")])]), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("To Joe, for listening to me rant about my characters the way some people rant about their coworkers: “Jen, are we talking about a real person now, or someone in your book?”")])]), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("And to Kevin Park, whom I forgot to mention in the last book, for literally saving my life and not holding the whole disgusting trip to the E.R. against me. Hopefully, subsequent birthdays have gone much better for you.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b7afb05","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bloodtiesbooktwopossession_fm1.vue
// module id = 66
// module chunks = 0